import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import usePermissions from '../../../hooks/usePermissions'

import Chip from '../../../components/Chip'
import Dropdown from '../../../components/Dropdown'

import { formatStringWithUnderscore } from '../../../helpers/common'

import { RIGHT_STATUS } from '../../../constants/permissions'

import useStyles from './styles'

const StatusUpdateDropdown = ({
  itemId,
  currentStatus,
  statuses = [],
  statusColors = {},
  onStatusUpdate,
  setIsStatusUpdateRunning
}) => {
  const classes = useStyles()

  const { t } = useTranslation()
  const permissions = usePermissions()

  const allowToUpdateRightStatus = permissions.can('update', RIGHT_STATUS)

  // filter current status to not display in update options
  const filteredStatuses = useMemo(() => statuses.filter(status => status !== currentStatus), [currentStatus, statuses])

  const statusClickHandler = useCallback(
    status => {
      setIsStatusUpdateRunning && setIsStatusUpdateRunning(true)

      onStatusUpdate(itemId, status)
    },
    [setIsStatusUpdateRunning, onStatusUpdate, itemId]
  )

  return (
    <Dropdown
      closeOnInsideClick
      placement="bottom-start"
      triggerElement={
        <Chip
          isHoverable={allowToUpdateRightStatus}
          text={t(formatStringWithUnderscore(currentStatus))}
          color={statusColors[currentStatus]}
        />
      }
      isDisabled={!allowToUpdateRightStatus}
    >
      <div className={classes.container}>
        {filteredStatuses.map(status => (
          <Chip
            key={status}
            isHoverable
            className={classes.statusChip}
            text={t(formatStringWithUnderscore(status))}
            color={statusColors[status]}
            onClick={() => statusClickHandler(status)}
          />
        ))}
      </div>
    </Dropdown>
  )
}

StatusUpdateDropdown.propTypes = {
  itemId: PropTypes.number,
  currentStatus: PropTypes.string,
  statuses: PropTypes.array.isRequired,
  statusColors: PropTypes.object.isRequired,
  onStatusUpdate: PropTypes.func.isRequired,
  setIsStatusUpdateRunning: PropTypes.func
}

export default StatusUpdateDropdown
